import { isSupabaseConfigured } from "@/lib/env";
import { supabase } from "@/lib/supabase";
import { resolveStoredAssetRef } from "@/features/image-generation";

export const TIMELINE_EVENT_IMAGES_BUCKET = "generated-images";

function ensureConfigured() {
  if (!isSupabaseConfigured()) {
    throw new Error("Supabase environment variables are not configured.");
  }
}

export async function createTimelineEventImageSignedUrl(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, TIMELINE_EVENT_IMAGES_BUCKET);

  if (!resolved) {
    throw new Error("Timeline event image path is missing.");
  }

  const { data, error } = await supabase.storage
    .from(resolved.bucket)
    .createSignedUrl(resolved.path, 60 * 30);

  if (error) {
    throw error;
  }

  return data.signedUrl;
}

export async function deleteTimelineEventImage(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, TIMELINE_EVENT_IMAGES_BUCKET);

  if (!resolved) {
    return;
  }

  const { error } = await supabase.storage
    .from(resolved.bucket)
    .remove([resolved.path]);

  if (error) {
    throw error;
  }
}
